import { useState, useEffect } from "react"
import { Input, Row, Col } from "reactstrap"
import moment from "moment-timezone"
import { gql, useQuery } from "@apollo/client"
import { GetConfigurationSettings } from "../Functions/querys"

const CurrentUser = gql`
  query UserQuery {
    currentUser {
      id
      member {
        id
        preferredTimezone
      }
    }
  }
`

const DEFAULT_TIMEZONE = "America/New_York"

const DateTimePicker = ({ id, name, type = "datetime-local", value, min, max, updateInput, setError, driverId, }) => {
    const { data: userData } = useQuery(CurrentUser, { fetchPolicy: "cache-and-network" });

    const { data: branchTimezone, loading: isBranchTimezoneLoading } = useQuery(GetConfigurationSettings, {
        skip: !driverId,
        variables: { driverId, name: "PREFERRED_TIMEZONE" },
        fetchPolicy: "cache-first",
    });

    const effectiveTimezone = branchTimezone?.getConfigurationSettings || userData?.currentUser?.member?.preferredTimezone || DEFAULT_TIMEZONE;

    const [timezone, setTimezone] = useState(effectiveTimezone)
    const [displayDatetime, setDisplayDatetime] = useState(
        value
            ? moment.utc(value).tz(effectiveTimezone).format(moment.HTML5_FMT.DATETIME_LOCAL)
            : moment().tz(effectiveTimezone).format(moment.HTML5_FMT.DATETIME_LOCAL)
    );

    useEffect(() => {
        if (!value) {
            let now = moment().tz(effectiveTimezone).format(moment.HTML5_FMT.DATETIME_LOCAL)
            setDisplayDatetime(now)
            updateInput(name, now)
        }
    }, [name, value])

    useEffect(() => {
        if (value) {
            let tzAdjustedValue = moment.utc(value).tz(effectiveTimezone).format(moment.HTML5_FMT.DATETIME_LOCAL)
            setDisplayDatetime(tzAdjustedValue)
        } else {
            let now = moment().tz(effectiveTimezone).format(moment.HTML5_FMT.DATETIME_LOCAL)
            setDisplayDatetime(now)
        }
        setTimezone(effectiveTimezone)
    }, [effectiveTimezone, value])

    useEffect(() => {
        if (!moment(displayDatetime).isValid()) {
            setError("Enter valid date time value")
            return
        }
        setError(null)

        let payloadDatetime = moment.tz(displayDatetime, timezone).format();
        updateInput(name, payloadDatetime)
    }, [displayDatetime])

    const handleDateChange = (e) => {
        let newDisplayDatetime = e.target.value;
        let newMoment = moment.tz(newDisplayDatetime, timezone);

        if (newMoment.isValid()) {
            if (
                newMoment.hour() === 0 &&
                newMoment.minute() === 0 &&
                newMoment.second() === 0
            ) {
                newMoment.set({ hour: 10, minute: 0, second: 0 })
            }
            newDisplayDatetime = newMoment.format(moment.HTML5_FMT.DATETIME_LOCAL)
        }

        setDisplayDatetime(newDisplayDatetime)
    };

    return (
        <Row>
            <Col xs="auto">
                <Input
                    type={type}
                    id={id}
                    name={name}
                    value={displayDatetime}
                    min={min}
                    max={max}
                    onInput={handleDateChange}
                />
                {isBranchTimezoneLoading ? (
                    <small className="text-muted">Loading timezone...</small>
                ) : (
                    <small className="text-muted">
                        {timezone} ({moment.tz(timezone).format("z")})
                    </small>
                )}
            </Col>
        </Row>
    );
};

export default DateTimePicker
